import { observable } from "mobx";

export type BaseSlipSelectionType = {
    masterEventId: number;
    eventId: number;
    type: number;
    lineId: number;
    leagueId: number;
    branchId: number;
    branchName: string;
    leagueName: string;
    eventTypeId: number;
    eventTypeName: string;
    oppositeEventTypeId: string;
    team1Name: string;
    team2Name: string;
    liveGroupId: number;
    preLiveGroupId: number;
    maxBet: number;
    minBet: number;
    waitingAllowed: boolean;
    singleSelectionRisk?: number;
    lineTypeName: string;
    odds: string | number;
}
export class BaseSlipSelection {

    masterEventId: number;
    eventId: number;
    lineId: number;
    type: number;
    leagueId: number;
    valid: boolean;
    final: boolean;
    @observable lastUpdate: Date;
    branchId: number;
    branchName: string;
    leagueName: string;
    eventTypeId: number;
    eventTypeName: string;
    oppositeEventTypeId: string;
    team1Name: string;
    team2Name: string;
    liveGroupId: number;
    preLiveGroupId: number;
    @observable maxBet: number;
    @observable minBet: number;
    waitingAllowed: boolean;
    singleSelectionRisk?: number;
    lineTypeName: string;
    initilized: boolean;
    // American odds
    @observable odds: string | number;

    constructor(source: BaseSlipSelectionType) {
        this.masterEventId = source.masterEventId;
        this.eventId = source.eventId;
        this.type = source.type;
        this.lineId = source.lineId;
        this.leagueId = source.leagueId;
        this.valid = true;
        this.final = true;
        this.lastUpdate = new Date();
        this.branchId = source.branchId;
        this.branchName = source.branchName;
        this.leagueName = source.leagueName;
        this.eventTypeId = source.eventTypeId;
        this.eventTypeName = source.eventTypeName;
        this.oppositeEventTypeId = source.oppositeEventTypeId;
        this.team1Name = source.team1Name;
        this.team2Name = source.team2Name;
        this.liveGroupId = source.liveGroupId;
        this.preLiveGroupId = source.preLiveGroupId;
        this.maxBet = source.maxBet;
        this.minBet = source.minBet;
        this.waitingAllowed = source.waitingAllowed;
        this.singleSelectionRisk = source.singleSelectionRisk;
        this.lineTypeName = source.lineTypeName;
        this.initilized = true;
        this.odds = source.odds;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./data/models/BaseSlipSelection/BaseSlipSelection.ts